import Page from 'components/Page/Page';
import Header from 'components/Header/Header';

const Harmony = () => {
  return (
    <Page>
      <Header title='Harmony' />
    </Page>
  );
};

export default Harmony;
